<template lang="pug">
  .container-forgetPassword
    h1.align-center 找回密码
    .forget-password-container-mobile(v-loading="loading", v-if="isMobile")
      .data-block(v-if="step === 0")
        data-row(label="用户名")
          el-input(v-model="source.login_name")
        data-row(label="验证方式")
          el-radio(v-model="source.verify_method", label="BY_PHONE") 手机号码
          el-radio(v-model="source.verify_method", label="BY_EMAIL") 邮箱地址
      template(v-if="step === 1")
        .data-block
          data-row(label="手机号码", v-if="source.verify_method === 'BY_PHONE'") {{ source.identifier }}
          data-row(label="邮箱地址", v-if="source.verify_method === 'BY_EMAIL'") {{ source.identifier }}
        .data-block
          data-row(label="图形验证码")
            el-input(v-model="source.captcha")
          data-row(label="点击更换验证码")
            img(:src="captcha_url", @click="getCaptcha", title="点击更换验证码").captcha
        .data-block
          data-row(:label="source.verify_method === 'BY_PHONE' ? '短信验证码' : '邮件验证码'")
            el-input(v-model="source.user_verify_code")
          data-row(label="")
            el-button(type="primary", @click="sendVerifyCode")
              template(v-if="!verify_locked") 获取
              template(v-else) {{ countdown }} s
        .data-block
          data-row(label="输入新密码", required)
            el-input(v-model="source.new_pass_word", type="password")
          el-form-item(value-only)
            .grey 密码长度应为 8 ~ 20 位
          data-row(label="重复新密码", required)
            el-input(v-model="source.re_new_pass_word", type="password")

      .data-block
        data-row(v-if="step === 0")
          el-button(@click="back()", slot="label") 返回
          el-button(type="primary", @click="startVerify()") 继续
        data-row(v-if="step === 1")
          el-button(@click="previous()", slot="label") 上一步
          el-button(type="primary", @click="editPassword()") 修改密码

    .forget-password-container(v-loading="loading", v-else)
      el-form(:model="source", label-position="right", label-width="100px", v-if="step === 0")
        el-form-item(label="用户名")
          el-input(v-model="source.login_name")
        el-form-item(label="验证方式")
          el-select(v-model="source.verify_method")
            el-option(value="BY_PHONE", label="手机号码")
            el-option(value="BY_EMAIL", label="邮箱地址")
      
      el-form(:model="source", label-position="right", label-width="125px", v-if="step === 1")
        el-form-item(label="")
          template(v-if="source.verify_method === 'BY_PHONE'") 手机号码： {{ source.identifier }}
          template(v-if="source.verify_method === 'BY_EMAIL'") 邮箱地址： {{ source.identifier }}
        el-form-item(label="图形验证码")
          el-input(v-model="source.captcha")
        el-form-item(label="")
          img(:src="captcha_url", @click="getCaptcha", title="点击更换图形验证码").captcha
        el-form-item(:label="source.verify_method === 'BY_PHONE' ? '短信验证码' : '邮件验证码'")
          el-input(v-model="source.user_verify_code")
            el-button(slot="append", @click="sendVerifyCode")
              template(v-if="!verify_locked") 获取
              template(v-else) {{ countdown }} s
        el-form-item(label="输入新密码", required)
          el-input(v-model="source.new_pass_word", type="password")
        el-form-item(label="") 密码长度应为 8 ~ 20 位
        el-form-item(label="重复新密码", required)
          el-input(v-model="source.re_new_pass_word", type="password")

      .forget-password-button-group
        template(v-if="step === 0")
          el-button(@click="back()") 返回
          el-button(type="primary", @click="startVerify()") 继续
        template(v-if="step === 1")
          el-button(@click="previous()") 上一步
          el-button(type="primary", @click="editPassword()") 修改密码
</template>

<script>
export default {
  data () {
    return {
      source:   {
        verify_method:  'BY_PHONE',   // 'BY_PHONE', 'BY_EMAIL'

        login_name:       null,
        biz_ticket:       null,
        captcha:          null,
        user_verify_code: null,
        identifier:       null,

        new_pass_word:    null,
        re_new_pass_word: null,
      },

      captcha_url:  null,

      loading:    false,
      step:       0,
      verify_locked:  false,
      countdown:      -1,

      isDesktop:  true,
    };
  },
  computed: {
    isMobile () {
      return window.browserInfo.isMobile;
    },
  },
  methods: {
    previous () {
      this.source = {
        verify_method:  'BY_PHONE',   // 'BY_PHONE', 'BY_EMAIL'

        login_name:       null,
        biz_ticket:       null,
        captcha:          null,
        user_verify_code: null,
        identifier:       null,

        new_pass_word:    null,
        re_new_pass_word: null,
      };
      this.step = 0;
      this.captcha_url = null;
    },

    startVerify () {
      if (!this.source.login_name) {
        this.$message({
          type:     'warning',
          message:  `请输入用户名`,
        });
        return;
      }

      this.loading = true;
      const params = {
        verify_method:  this.source.verify_method,
        scene:          'FORGET_PASSWORD',
        opt:            'MCH_VERIFY',
        login_name:     this.source.login_name,
      };

      this.$store.dispatch('START_VERIFY', params).then((data) => {
        this.source.biz_ticket = data.biz_ticket;
        this.source.identifier = data.identifier;

        this.getCaptcha();

        this.step++;
      }).catch(({ code, msg }) => {
        if (code === 41003) {
          this.$alert('用户不存在', {
            type:   'error'
          });
        } else if (code === 43001 || code === 42104 || code === 42101) {
          const hint = this.source.verify_method === 'BY_PHONE' ? '该账号尚未绑定手机号码' : '该账号尚未绑定邮箱地址';
          this.$alert(`${hint}`, {
            type:     'warning'
          }).then(() => {

          });
        } else {
          this.$message({
            type:     'error',
            message:  `用户信息验证初始化失败。${code}：${msg}`,
          });
        }
      }).finally(() => {
        this.loading = false;
      });
    },

    getCaptcha () {
      return this.$store.dispatch('GET_CAPTCHA', this.source.biz_ticket).then(({ captcha_url }) => {
        this.captcha_url = captcha_url;
        return captcha_url;
      }).catch(({ code, msg }) => {
        this.$message({
          type:     'error',
          message:  `获取图形验证码失败。${code}：${msg}`,
        });
      });
    },

    startCountdown () {
      this.countdown = 60;
      this.verify_locked = true;
      const t = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          this.verify_locked = false;
          clearInterval(t);
        }
      }, 1000);
    },

    sendVerifyCode () { // Send Code through SMS or Email
      const params = {
        captcha:    this.source.captcha,
        biz_ticket: this.source.biz_ticket,
      };

      this.$store.dispatch('SEND_VERIFY_CODE', params).then(() => {
        this.startCountdown();
        this.$message({
          type:     'success',
          message:  '验证码已发出，请注意查收',
        });
      }).catch(({ code, msg }) => {
        this.$message({
          type:     'error',
          message:  `验证码发送失败。${code}：${msg}`,
        });
        if (code === 43002) {
          this.source.captcha = null;
          this.getCaptcha();
        }
      });
    },

    editPassword () {
      if (!this.source.captcha) {
        this.$message({
          type:     'warning',
          message:  `请输入有效的图形验证码`,
        });
        return;
      }
      if (this.source.verify_method === 'BY_PHONE') {
        if (!this.source.user_verify_code) {
          this.$message({
            type:     'warning',
            message:  `请输入短信验证码`,
          });
          return;
        }
      } else if (this.source.verify_method === 'BY_EMAIL') {
        if (!this.source.user_verify_code) {
          this.$message({
            type:     'warning',
            message:  `请输入邮件验证码`,
          });
          return;
        }
      }
      if (!this.source.new_pass_word) {
        this.$message({
          type:     'warning',
          message:  `请输入新密码`,
        });
        return;
      } else if (this.source.new_pass_word.length < 8 || this.source.new_pass_word.length > 20) {
        this.$message({
          type:     'warning',
          message:  `密码长度应为 8 ~ 20 位`
        });
        return;
      } else if (this.source.new_pass_word !== this.source.re_new_pass_word) {
        this.$message({
          type:     'warning',
          message:  `两次输入的密码不一致`,
        });
        return;
      }

      const params = {
        user_verify_code: this.source.user_verify_code,
        biz_ticket:       this.source.biz_ticket,
      };
      return this.$store.dispatch('IDENTITY_VERIFY', params).then(() => {
        const params = {
          new_pass_word:    this.source.new_pass_word,
          biz_ticket:       this.source.biz_ticket,
        };

        return this.$store.dispatch('FORGET_PASSWORD', params).then(() => {
          this.$alert('密码重置成功。稍后将返回登陆页面……', {
            type:   'success'
          });

          setTimeout(() => {
            this.$router.replace('/login');
            location.reload();
          }, 1000);
        }).catch(({ code, msg }) => {
          this.$message({
            type:     'error',
            message:  `密码重置失败。${code}：${msg}`,
          });
        });
      }).catch(({ code, msg }) => {
        this.$message({
          type:     'error',
          message:  `用户身份验证失败。${code}：${msg}`,
        });
      });
    },

    back () {
      this.$router.push('/');
    },
  },
  mounted () {
    window.onresize = () => {
      this.isDesktop = window.screen.width >= 500;
    };
    window.onresize();
  }
};
</script>

<style lang="less">
@import (reference) "../assets/general";

.container-forgetPassword {
  .flex(center, center, column);
  .max-height;
  // .max-width;

  background: url('../assets/bg_login.jpg') center center no-repeat;
  background-size: cover;

  .forget-password-container {
    .border-box;
    width:          440px;
    margin:         2em auto;
    padding:        20px 20px;

    // background:    rgba(255,255,255,0.4);
    background:     @white;
    border-radius:  4px;

    @media screen and (max-width: 500px) {
      .max-width;
    }
  }

  .forget-password-button-group {
    .flex(center, space-between, row);

    margin-top:       40px;

    .el-button {
      .max-width;
    }
  }

  .captcha {
    .cursor-pointer;
  }
}

.forget-password-container-mobile{
  width:        100%;
  margin:       2em auto;
  padding:      20px 0;
  background:   @background-grey-2;

  .forget-password-button-group {
    .el-button {
      width:  inherit;
    }
  }
}
</style>